import { css } from '@emotion/react';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  paddingRight: theme.spacing(2.25),
  gap: theme.spacing(2),
  flex: 1,
  flexShrink: 0,
  maxHeight: 280,
});

export type PaymentMethodsListContainerProps = React.PropsWithChildren<{
  isLoading: boolean;
  className?: string;
}>;
export const PaymentMethodsListContainer = ({ isLoading, children, className }: PaymentMethodsListContainerProps) => {
  if (isLoading) {
    return <PaymentMethodListLoader className={className} />;
  }

  return (
    <div
      className={classNames('payment-methods__list-container', className)}
      css={containerStyles}
      data-testid='payment-methods-list-container'
    >
      {children}
    </div>
  );
};

export type PaymentMethodListLoaderProps = {
  className?: string;
};

export const PaymentMethodListLoader = ({ className }: PaymentMethodListLoaderProps) => {
  return (
    <div
      className={classNames('payment-methods__list-loader', className)}
      css={containerStyles}
      data-testid='payment-methods-list-loader'
    >
      {[1, 2].map((val) => (
        <div key={val} css={{ width: '100%', height: 82, flexShrink: 0 }}>
          <SkeletonLoader />
        </div>
      ))}
    </div>
  );
};
